var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collection_container"},[_c('div',{staticClass:"container_main"},[_vm._m(0),_c('div',{staticClass:"main_null"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main_box"},[_c('img',{attrs:{"src":"https://files.wondercv.com/company/privacy-company-zero.png","alt":""}})])
}]

export { render, staticRenderFns }